export type ResourceAuthorization = {
  resourceName: string;
  requiredAnyRoles: string[];
};

export const userRolesMatchAnyRequiredUserRoles = (
  resourceName: ResourceAuthorization['resourceName'],
  requiredAnyRoles: ResourceAuthorization['requiredAnyRoles'],
  userRoles: string[] | undefined,
): boolean => {
  if (!userRoles) {
    return false;
  }

  const rolesMatch = !requiredAnyRoles || requiredAnyRoles.length === 0 || requiredAnyRoles.some(requiredRole => {
    return userRoles.find(userRole => {
      if (!userRole?.includes(':')) {
        return false;
      }
      const [clientId, role] = userRole.split(':');
      return role.toLocaleLowerCase() === requiredRole.toLowerCase() && clientId.toLowerCase() === resourceName.toLowerCase();
    });
  });

  const clientMatch = userRoles.some(userRole => {
    if (!userRole.includes(':')) {
      return false;
    }
    const [clientId] = userRole.split(':');
    return clientId.toLowerCase() === resourceName.toLowerCase();
  });

  return rolesMatch && clientMatch;
};
